module.exports = __webpack_public_path__ + "static/media/media and entertainment.72ad18b3.jpg";